const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLearning04(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1332 1000",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1333.33,993.75l-1333.33,-0l0,-952.083c0,-11.051 4.39,-21.649 12.204,-29.463c7.814,-7.814 18.412,-12.204 29.463,-12.204c198.977,-0 1051.02,-0 1250,-0c11.05,-0 21.648,4.39 29.462,12.204c7.814,7.814 12.204,18.412 12.204,29.463c0,188.469 0,952.083 0,952.083Z",
    style: {
      fill: "#f7e2ad",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1167.98,842.425l-969.143,-0c-5.227,-0 -9.464,-4.235 -9.464,-9.464l-0,-16.563c-0,-5.229 4.237,-9.464 9.464,-9.464l969.143,-0c5.229,-0 9.464,4.235 9.464,9.464l0,16.563c0,5.229 -4.235,9.464 -9.464,9.464Z",
    style: {
      fill: "#b4762a",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.074,793.599l-157.843,-0c-8.982,-0 -16.848,-4.837 -21.146,-12.039c-1.334,-2.233 -2.323,-4.704 -2.888,-7.325c-0.372,-1.69 -0.566,-3.441 -0.566,-5.234c0,-1.065 0.068,-2.111 0.199,-3.142c0.33,-2.593 1.068,-5.049 2.141,-7.33c3.941,-8.343 12.436,-14.13 22.26,-14.13l157.266,-0c-3.583,4.807 -5.821,9.554 -7.046,14.13c-0.672,2.498 -1.044,4.95 -1.175,7.33c-0.157,2.901 0.047,5.697 0.513,8.376c0.444,2.569 1.135,5.021 1.972,7.325c1.728,4.723 4.089,8.816 6.313,12.039Z",
    style: {
      fill: "#e9f7fe",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.576,801.449l-164.345,0c-17.922,0 -32.451,-14.527 -32.451,-32.448c0,-8.963 3.633,-17.074 9.505,-22.946c5.872,-5.873 13.985,-9.507 22.946,-9.507l164.345,-0c-2.797,2.622 -5.134,5.243 -7.079,7.851l-157.266,-0c-9.824,-0 -18.319,5.787 -22.26,14.13c-1.073,2.281 -1.811,4.737 -2.141,7.33c-0.131,1.031 -0.199,2.077 -0.199,3.142c0,1.793 0.194,3.544 0.566,5.234c0.565,2.621 1.554,5.092 2.888,7.325c4.298,7.202 12.164,12.039 21.146,12.039l157.843,-0c3.407,4.945 6.502,7.85 6.502,7.85Z",
    style: {
      fill: "#527fbd",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.285,746.055c-5.872,5.872 -9.505,13.983 -9.505,22.946c0,17.921 14.529,32.448 32.451,32.448l164.345,0l-0,7.851l-164.345,-0c-22.224,-0 -40.301,-18.077 -40.301,-40.299c-0,-22.227 18.077,-40.304 40.301,-40.304l164.345,0l-0,7.851l-164.345,-0c-8.961,-0 -17.074,3.634 -22.946,9.507Z",
    style: {
      fill: "#527fbd",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.451,758.529c-0.672,2.498 -1.044,4.95 -1.175,7.33l-173.446,-0c0.33,-2.593 1.068,-5.049 2.141,-7.33l172.48,-0Z",
    style: {
      fill: "#bde2f5",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.761,781.56l-172.676,0c-1.334,-2.233 -2.323,-4.704 -2.888,-7.325l173.592,-0c0.444,2.569 1.135,5.021 1.972,7.325Z",
    style: {
      fill: "#bde2f5",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.653,632.393l-157.844,0c-8.981,0 -16.847,-4.836 -21.144,-12.038c-1.335,-2.234 -2.324,-4.704 -2.889,-7.325c-0.372,-1.685 -0.566,-3.441 -0.566,-5.234c0,-1.065 0.068,-2.111 0.199,-3.142c0.33,-2.589 1.068,-5.05 2.141,-7.326c3.941,-8.342 12.435,-14.13 22.259,-14.13l157.268,0c-3.585,4.803 -5.82,9.55 -7.05,14.13c-0.67,2.494 -1.041,4.945 -1.172,7.326c-0.157,2.9 0.047,5.702 0.513,8.376c0.445,2.569 1.136,5.025 1.973,7.325c1.727,4.723 4.088,8.816 6.312,12.038Z",
    style: {
      fill: "#e9f7fe",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.154,640.244l-164.345,0c-17.92,0 -32.449,-14.528 -32.449,-32.448c-0,-8.963 3.632,-17.074 9.504,-22.946c5.873,-5.873 13.985,-9.503 22.945,-9.503l164.345,0c-2.796,2.622 -5.135,5.244 -7.077,7.851l-157.268,0c-9.824,0 -18.318,5.788 -22.259,14.13c-1.073,2.276 -1.811,4.737 -2.141,7.326c-0.131,1.031 -0.199,2.077 -0.199,3.142c0,1.793 0.194,3.549 0.566,5.234c0.565,2.621 1.554,5.091 2.889,7.325c4.297,7.202 12.163,12.038 21.144,12.038l157.844,0c3.406,4.946 6.501,7.851 6.501,7.851Z",
    style: {
      fill: "#8fc3e1",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.864,584.85c-5.872,5.872 -9.504,13.983 -9.504,22.946c-0,17.92 14.529,32.448 32.449,32.448l164.345,0l0,7.851l-164.345,-0c-22.223,-0 -40.3,-18.077 -40.3,-40.299c-0,-22.222 18.077,-40.304 40.3,-40.304l164.345,0l0,7.855l-164.345,0c-8.96,0 -17.072,3.63 -22.945,9.503Z",
    style: {
      fill: "#8fc3e1",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.027,597.328c-0.67,2.494 -1.041,4.945 -1.172,7.326l-173.446,-0c0.33,-2.589 1.068,-5.05 2.141,-7.326l172.477,0Z",
    style: {
      fill: "#bde2f5",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.341,620.355l-172.676,-0c-1.335,-2.234 -2.324,-4.704 -2.889,-7.325l173.592,-0c0.445,2.569 1.136,5.025 1.973,7.325Z",
    style: {
      fill: "#bde2f5",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.821,712.996l-204.947,0c-8.981,0 -16.848,-4.836 -21.145,-12.039c-1.335,-2.233 -2.324,-4.703 -2.889,-7.325c-0.372,-1.685 -0.565,-3.44 -0.565,-5.234c-0,-1.064 0.068,-2.11 0.199,-3.142c0.329,-2.588 1.067,-5.049 2.14,-7.325c3.941,-8.343 12.436,-14.135 22.26,-14.135l204.375,-0c-3.587,4.808 -5.821,9.554 -7.051,14.135c-0.672,2.494 -1.042,4.945 -1.174,7.325c-0.157,2.901 0.047,5.702 0.511,8.376c0.444,2.57 1.136,5.026 1.973,7.325c1.727,4.723 4.089,8.816 6.313,12.039Z",
    style: {
      fill: "#e9f7fe",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.323,720.847l-211.449,-0c-17.921,-0 -32.45,-14.528 -32.45,-32.449c-0,-8.962 3.632,-17.073 9.505,-22.946c5.872,-5.872 13.985,-9.507 22.945,-9.507l211.449,0c-2.797,2.622 -5.134,5.248 -7.074,7.851l-204.375,-0c-9.824,-0 -18.319,5.792 -22.26,14.135c-1.073,2.276 -1.811,4.737 -2.14,7.325c-0.131,1.032 -0.199,2.078 -0.199,3.142c-0,1.794 0.193,3.549 0.565,5.234c0.565,2.622 1.554,5.092 2.889,7.325c4.297,7.203 12.164,12.039 21.145,12.039l204.947,0c3.407,4.945 6.502,7.851 6.502,7.851Z",
    style: {
      fill: "#62a0c2",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.929,665.452c-5.873,5.873 -9.505,13.984 -9.505,22.946c-0,17.921 14.529,32.449 32.45,32.449l211.449,-0l0,7.85l-211.449,0c-22.223,0 -40.301,-18.076 -40.301,-40.299c0,-22.227 18.078,-40.303 40.301,-40.303l211.449,-0l0,7.85l-211.449,0c-8.96,0 -17.073,3.635 -22.945,9.507Z",
    style: {
      fill: "#62a0c2",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.198,677.931c-0.672,2.494 -1.042,4.945 -1.174,7.325l-220.55,0c0.329,-2.588 1.067,-5.049 2.14,-7.325l219.584,-0Z",
    style: {
      fill: "#8fc3e1",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.508,700.957l-219.779,0c-1.335,-2.233 -2.324,-4.703 -2.889,-7.325l220.695,0c0.444,2.57 1.136,5.026 1.973,7.325Z",
    style: {
      fill: "#8fc3e1",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.326,508.52l-26.878,-56.28l4.27,-2.04l26.878,56.281l-4.27,2.039Z",
    style: {
      fill: "#7fa2d4",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.745,503.069c2.45,5.125 0.277,11.267 -4.85,13.713c-5.128,2.452 -11.268,0.28 -13.717,-4.85c-2.449,-5.125 -0.277,-11.267 4.85,-13.714c5.127,-2.451 11.268,-0.279 13.717,4.851Z",
    style: {
      fill: "#527fbd",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.992,567.402c-51.41,45.514 -93.999,69.175 -166.366,79.453c-0.026,0.005 -41.424,-86.688 -41.424,-86.688l166.536,-79.533c-0,-0 41.378,86.655 41.254,86.768Z",
    style: {
      fill: "#527fbd",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.335,569.749l106.232,-110.276l152.54,-13.31l-106.232,110.275l-152.54,13.311Z",
    style: {
      fill: "#7fa2d4",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.64,806.934l-449.553,-0c-15.682,-0 -28.393,-12.711 -28.393,-28.393l0,-14.196l506.339,-0l0,14.196c0,15.682 -12.71,28.393 -28.393,28.393Z",
    style: {
      fill: "#3464a8",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M856.136,783.746l-96.536,0c-10.714,0 -19.402,-8.688 -19.402,-19.401l135.339,-0c0,10.713 -8.688,19.401 -19.401,19.401Z",
    style: {
      fill: "#7fa2d4",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1028.39,764.345l-441.036,-0l-0,-236.608c-0,-20.906 16.95,-37.857 37.857,-37.857l365.321,0c20.907,0 37.858,16.951 37.858,37.857l-0,236.608Z",
    style: {
      fill: "#527fbd",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.475,731.22l-0,-203.483c-0,-2.607 2.125,-4.732 4.732,-4.732l365.321,0c2.608,0 4.733,2.125 4.733,4.732l-0,203.483l-374.786,-0Z",
    style: {
      fill: "#8fc3e1",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.868,556.367c-39.007,-0 -70.746,31.738 -70.746,70.745c0,39.007 31.739,70.746 70.746,70.746c39.007,-0 70.745,-31.739 70.745,-70.746c0,-39.007 -31.738,-70.745 -70.745,-70.745Zm-0,158.053c-48.14,0 -87.308,-39.168 -87.308,-87.308c-0,-48.14 39.168,-87.308 87.308,-87.308c48.14,0 87.308,39.168 87.308,87.308c-0,48.14 -39.168,87.308 -87.308,87.308Z",
    style: {
      fill: "#e9f7fe",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M780.421,664.023l0,-73.821l73.822,36.91l-73.822,36.911Z",
    style: {
      fill: "#e9f7fe",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M901.564,152.895c0,0.449 -0.005,0.894 -0.019,1.339c-0.255,10.27 -3.483,19.803 -8.844,27.774c-0.615,0.914 -1.259,1.807 -1.931,2.677c-8.262,10.749 -20.618,18.191 -34.734,19.991c-1.755,0.225 -3.535,0.359 -5.338,0.405c-0.445,0.01 -0.889,0.017 -1.339,0.017c-0.445,0 -0.889,-0.007 -1.334,-0.017c-1.803,-0.046 -3.583,-0.18 -5.338,-0.405c-14.116,-1.8 -26.472,-9.242 -34.739,-19.991c-0.667,-0.87 -1.311,-1.763 -1.926,-2.677c-5.361,-7.971 -8.589,-17.504 -8.849,-27.774c-0.009,-0.445 -0.014,-0.89 -0.014,-1.339c-0,-0.448 0.005,-0.894 0.014,-1.338c0.251,-9.986 3.308,-19.272 8.409,-27.106c0.592,-0.913 1.211,-1.807 1.865,-2.677c8.262,-11.11 20.83,-18.82 35.24,-20.66c1.755,-0.224 3.535,-0.358 5.338,-0.405c0.445,-0.01 0.889,-0.017 1.334,-0.017c0.45,0 0.894,0.007 1.339,0.017c1.803,0.047 3.583,0.181 5.338,0.405c14.405,1.84 26.978,9.55 35.24,20.66c0.649,0.87 1.273,1.764 1.865,2.677c5.101,7.834 8.153,17.12 8.404,27.106c0.014,0.444 0.019,0.89 0.019,1.338Z",
    style: {
      fill: "#62a0c2",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 848.025,
    y: 100.692,
    width: 2.674,
    height: 104.406,
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M901.564,152.895c0,0.449 -0.005,0.894 -0.019,1.339l-104.372,-0c-0.009,-0.445 -0.014,-0.89 -0.014,-1.339c-0,-0.448 0.005,-0.894 0.014,-1.338l104.372,-0c0.014,0.444 0.019,0.89 0.019,1.338Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M868.24,182.008c-0.288,0.914 -0.596,1.804 -0.922,2.677c-0.587,1.587 -1.217,3.106 -1.893,4.555c-4.056,8.66 -9.242,13.723 -14.727,14.433c-0.445,0.056 -0.889,0.087 -1.339,0.087c-0.445,-0 -0.889,-0.031 -1.334,-0.087c-5.485,-0.71 -10.671,-5.773 -14.727,-14.433c-0.676,-1.449 -1.306,-2.968 -1.893,-4.555c-0.326,-0.873 -0.634,-1.763 -0.922,-2.677c-2.622,-8.128 -4.084,-17.702 -4.203,-27.774c-0.004,-0.445 -0.009,-0.894 -0.009,-1.339c0,-0.445 0.005,-0.894 0.009,-1.338c0.114,-9.799 1.501,-19.125 3.99,-27.106c0.284,-0.91 0.577,-1.803 0.889,-2.677c0.653,-1.827 1.368,-3.574 2.139,-5.223c4.056,-8.661 9.242,-13.724 14.727,-14.433c0.445,-0.057 0.889,-0.087 1.334,-0.087c0.45,0 0.894,0.03 1.339,0.087c5.485,0.709 10.671,5.772 14.727,14.433c0.771,1.649 1.486,3.396 2.139,5.223c0.307,0.874 0.605,1.767 0.889,2.677c2.489,7.981 3.876,17.307 3.99,27.106c0.004,0.444 0.009,0.893 0.009,1.338c-0,0.445 -0.005,0.894 -0.009,1.339c-0.119,10.072 -1.581,19.646 -4.203,27.774Zm6.881,-30.451c-0.114,-9.738 -1.458,-19.044 -3.871,-27.106c-0.27,-0.91 -0.554,-1.803 -0.856,-2.677c-0.762,-2.239 -1.614,-4.364 -2.546,-6.358c-3.28,-7 -7.34,-11.879 -11.812,-14.302c-1.755,-0.224 -3.535,-0.358 -5.338,-0.405l0,-0.017l-2.673,0l-0,0.017c-1.803,0.047 -3.583,0.181 -5.338,0.405c-4.472,2.423 -8.537,7.302 -11.812,14.302c-0.932,1.994 -1.788,4.119 -2.546,6.358c-0.302,0.874 -0.586,1.767 -0.856,2.677c-2.418,8.062 -3.757,17.368 -3.871,27.106c-0.005,0.444 -0.009,0.89 -0.009,1.338c-0,0.449 0.004,0.894 0.009,1.339c0.118,10.009 1.533,19.559 4.074,27.774c0.28,0.91 0.573,1.801 0.885,2.677c0.701,1.992 1.477,3.892 2.314,5.689c3.275,7.001 7.34,11.88 11.812,14.302c1.755,0.225 3.535,0.359 5.338,0.405l-0,0.017l2.673,0l0,-0.017c1.803,-0.046 3.583,-0.18 5.338,-0.405c4.472,-2.422 8.532,-7.301 11.812,-14.302c0.837,-1.797 1.613,-3.697 2.314,-5.689c0.312,-0.876 0.605,-1.767 0.885,-2.677c2.541,-8.215 3.956,-17.765 4.074,-27.774c0.005,-0.445 0.005,-0.89 0.005,-1.339c-0,-0.448 -0,-0.894 -0.005,-1.338Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M893.141,124.451l-87.559,-0c0.592,-0.913 1.211,-1.807 1.865,-2.677l83.829,-0c0.649,0.87 1.273,1.764 1.865,2.677Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.701,182.008c-0.615,0.914 -1.259,1.807 -1.931,2.677l-82.822,0c-0.667,-0.87 -1.311,-1.763 -1.926,-2.677l86.679,0Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.532,274.568c-0.605,-0 -1.211,-0.231 -1.672,-0.693c-0.925,-0.924 -0.925,-2.422 -0,-3.347c2.748,-2.748 5.634,-5.531 8.576,-8.269c0.956,-0.891 2.454,-0.837 3.344,0.119c0.89,0.957 0.837,2.454 -0.119,3.344c-2.902,2.701 -5.746,5.443 -8.455,8.153c-0.463,0.462 -1.068,0.693 -1.674,0.693Z",
    style: {
      fill: "#b4762a",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.494,213.289c-0.789,-0 -1.561,-0.395 -2.009,-1.114c-0.692,-1.108 -0.355,-2.567 0.754,-3.26c7.284,-4.546 14.828,-9.027 22.423,-13.318c1.136,-0.643 2.581,-0.242 3.224,0.897c0.642,1.137 0.241,2.581 -0.897,3.224c-7.535,4.257 -15.019,8.702 -22.244,13.212c-0.39,0.243 -0.823,0.359 -1.251,0.359Zm-46.775,32.792c-0.698,0 -1.388,-0.307 -1.855,-0.897c-0.812,-1.024 -0.64,-2.512 0.385,-3.323c6.621,-5.247 13.656,-10.506 20.908,-15.631c1.066,-0.755 2.543,-0.501 3.298,0.566c0.754,1.067 0.5,2.544 -0.567,3.298c-7.182,5.076 -14.147,10.283 -20.701,15.476c-0.435,0.344 -0.953,0.511 -1.468,0.511Z",
    style: {
      fill: "#b4762a",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.349,185.4c-0.869,0 -1.706,-0.48 -2.12,-1.311c-0.583,-1.17 -0.107,-2.59 1.063,-3.173c3.555,-1.771 7.15,-3.517 10.686,-5.188c1.181,-0.558 2.591,-0.053 3.15,1.129c0.558,1.181 0.053,2.591 -1.129,3.149c-3.505,1.657 -7.071,3.389 -10.597,5.146c-0.339,0.168 -0.699,0.248 -1.053,0.248Z",
    style: {
      fill: "#b4762a",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.422,129.244c-1.022,-0 -1.959,-0.663 -2.266,-1.688c-0.374,-1.252 0.336,-2.571 1.585,-2.946c3.762,-1.127 7.623,-2.211 11.471,-3.221c1.258,-0.331 2.555,0.424 2.886,1.688c0.331,1.264 -0.421,2.557 -1.684,2.889c-3.796,0.997 -7.605,2.065 -11.315,3.177c-0.227,0.068 -0.454,0.101 -0.677,0.101Z",
    style: {
      fill: "#b4762a",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.16,113.803c-1.268,0 -2.319,-1.009 -2.361,-2.288c-0.043,-1.306 0.979,-2.4 2.285,-2.443c4.799,-0.158 9.682,-0.238 14.523,-0.238c3.743,0 7.553,0.048 11.315,0.142c1.306,0.033 2.337,1.119 2.309,2.425c-0.033,1.307 -1.126,2.344 -2.427,2.306c-3.725,-0.093 -7.492,-0.14 -11.197,-0.14c-4.789,-0 -9.625,0.079 -14.367,0.235c-0.028,0.001 -0.052,0.001 -0.08,0.001Zm82.013,4.746c-0.114,0 -0.227,-0.008 -0.341,-0.025c-8.433,-1.232 -16.974,-2.249 -25.397,-3.023c-1.302,-0.119 -2.262,-1.271 -2.139,-2.572c0.118,-1.301 1.273,-2.258 2.569,-2.14c8.509,0.781 17.14,1.808 25.648,3.053c1.292,0.189 2.191,1.39 2.002,2.683c-0.175,1.177 -1.183,2.024 -2.342,2.024Zm-138.231,0.951c-1.126,-0 -2.129,-0.811 -2.328,-1.962c-0.222,-1.287 0.639,-2.513 1.926,-2.736c8.366,-1.455 16.984,-2.66 25.606,-3.582c1.306,-0.142 2.465,0.802 2.602,2.101c0.142,1.3 -0.8,2.465 -2.101,2.604c-8.518,0.911 -17.031,2.102 -25.298,3.539c-0.137,0.024 -0.27,0.036 -0.407,0.036Z",
    style: {
      fill: "#b4762a",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M755.085,126.566c-0.179,0 -0.364,-0.021 -0.549,-0.064c-3.799,-0.9 -7.661,-1.767 -11.484,-2.576c-1.283,-0.271 -2.097,-1.526 -1.827,-2.805c0.27,-1.278 1.524,-2.095 2.806,-1.825c3.857,0.817 7.761,1.692 11.599,2.601c1.268,0.302 2.058,1.577 1.755,2.848c-0.26,1.088 -1.23,1.821 -2.3,1.821Z",
    style: {
      fill: "#b4762a",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955.383,179.817c-0.251,0 -0.511,-0.04 -0.762,-0.126c-3.795,-1.292 -7.557,-2.472 -11.177,-3.511c-1.254,-0.359 -1.983,-1.67 -1.624,-2.926c0.36,-1.256 1.671,-1.983 2.93,-1.622c3.691,1.058 7.524,2.263 11.395,3.579c1.235,0.421 1.897,1.765 1.476,3.002c-0.336,0.985 -1.254,1.604 -2.238,1.604Z",
    style: {
      fill: "#b4762a",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1000.86,199.312c-0.36,0 -0.729,-0.083 -1.07,-0.258c-6.79,-3.457 -13.59,-6.685 -20.215,-9.594c-1.193,-0.526 -1.738,-1.922 -1.212,-3.118c0.525,-1.196 1.917,-1.741 3.118,-1.215c6.701,2.946 13.587,6.212 20.453,9.71c1.169,0.593 1.628,2.017 1.036,3.182c-0.416,0.82 -1.249,1.293 -2.11,1.293Zm42.816,24.852c-0.445,0 -0.894,-0.125 -1.296,-0.386c-6.219,-4.07 -12.626,-8.043 -19.033,-11.808c-1.126,-0.662 -1.505,-2.112 -0.842,-3.239c0.662,-1.127 2.115,-1.503 3.241,-0.842c6.474,3.804 12.942,7.818 19.227,11.929c1.093,0.715 1.4,2.182 0.686,3.275c-0.454,0.694 -1.212,1.071 -1.983,1.071Zm39.831,29.386c-0.535,-0 -1.075,-0.181 -1.515,-0.551c-5.551,-4.642 -11.461,-9.301 -17.575,-13.849c-1.05,-0.78 -1.268,-2.262 -0.487,-3.311c0.78,-1.049 2.262,-1.266 3.312,-0.486c6.185,4.602 12.171,9.318 17.784,14.016c1.003,0.839 1.135,2.331 0.298,3.333c-0.469,0.559 -1.141,0.848 -1.817,0.848Z",
    style: {
      fill: "#b4762a",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1111.67,280.23c-0.643,-0 -1.282,-0.26 -1.751,-0.772c-2.536,-2.781 -5.267,-5.625 -8.111,-8.454c-0.922,-0.921 -0.927,-2.419 -0.009,-3.346c0.923,-0.926 2.423,-0.93 3.346,-0.009c2.9,2.882 5.683,5.783 8.271,8.62c0.881,0.966 0.814,2.462 -0.156,3.343c-0.449,0.414 -1.022,0.618 -1.59,0.618Z",
    style: {
      fill: "#b4762a",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1189.27,331.993l-0.975,-4.631c7.245,-1.524 12.412,-4.598 15.365,-9.135c2.702,-4.156 2.939,-8.589 2.807,-11.025l-13.052,0l0,-4.732l17.074,0l0.397,1.874c0.076,0.352 1.78,8.721 -3.26,16.463c-3.663,5.63 -9.838,9.393 -18.356,11.186Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1136.79,331.993c-8.518,-1.793 -14.694,-5.556 -18.356,-11.186c-5.04,-7.742 -3.332,-16.111 -3.261,-16.463l0.402,-1.874l17.074,0l-0,4.732l-13.066,0c-0.269,4.651 0.829,16.507 18.181,20.16l-0.974,4.631Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1156.86,
    y: 348.625,
    width: 12.209,
    height: 13.473,
    style: {
      fill: "#8fc3e1",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1166.33,352.414l-6.734,-0c-13.719,-0 -24.844,-11.122 -24.844,-24.842l-4.207,-34.525l64.84,0l-4.212,34.525c0,13.72 -11.12,24.842 -24.843,24.842Z",
    style: {
      fill: "#8fc3e1",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1127.17,
    y: 288.416,
    width: 71.574,
    height: 4.631,
    style: {
      fill: "#62a0c2",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1184.23,372.203l-42.528,-0l-0,-5.895c-0,-2.325 1.888,-4.21 4.211,-4.21l34.105,-0c2.323,-0 4.212,1.885 4.212,4.21l-0,5.895Z",
    style: {
      fill: "#62a0c2",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1193.06,377.255l-60.207,0l0,-0.842c0,-2.325 1.883,-4.21 4.212,-4.21l51.788,-0c2.324,-0 4.207,1.885 4.207,4.21l0,0.842Z",
    style: {
      fill: "#62a0c2",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.073,
    y: 163.599,
    width: 28.866,
    height: 42.116,
    style: {
      fill: "#62a0c2",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.073,
    y: 147.273,
    width: 28.866,
    height: 16.326,
    style: {
      fill: "#8fc3e1",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 441.662,
    y: 139.938,
    width: 28.866,
    height: 65.777,
    style: {
      fill: "#62a0c2",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 441.662,
    y: 123.612,
    width: 28.866,
    height: 16.326,
    style: {
      fill: "#8fc3e1",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 484.251,
    y: 116.278,
    width: 28.866,
    height: 89.437,
    style: {
      fill: "#62a0c2",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 484.251,
    y: 99.952,
    width: 28.866,
    height: 16.326,
    style: {
      fill: "#8fc3e1",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.059,
    y: 205.952,
    width: 141.017,
    height: 4.259,
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.013,365.145l-4.732,0l0,-49.912c0,-22.506 -18.31,-40.815 -40.815,-40.815c-22.506,-0 -40.817,18.309 -40.817,40.815l0,49.912l-4.732,0l0,-49.912c0,-25.115 20.433,-45.547 45.549,-45.547c25.115,-0 45.547,20.432 45.547,45.547l0,49.912Z",
    style: {
      fill: "#62a0c2",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.385,372.996l-9.515,0c-4.85,0 -8.782,-3.932 -8.782,-8.783l-0,-25.616c-0,-4.85 3.932,-8.782 8.782,-8.782l9.515,-0c4.85,-0 8.783,3.932 8.783,8.782l-0,25.616c-0,4.851 -3.933,8.783 -8.783,8.783Z",
    style: {
      fill: "#8fc3e1",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.48,335.983c-8.053,0 -14.582,6.528 -14.582,14.581c0,8.053 6.529,14.581 14.582,14.581l-0,-29.162Z",
    style: {
      fill: "#e9f7fe",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.555,372.996l9.515,0c4.85,0 8.783,-3.932 8.783,-8.783l-0,-25.616c-0,-4.85 -3.933,-8.782 -8.783,-8.782l-9.515,-0c-4.851,-0 -8.783,3.932 -8.783,8.782l0,25.616c0,4.851 3.932,8.783 8.783,8.783Z",
    style: {
      fill: "#8fc3e1",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.461,335.983c8.052,0 14.58,6.528 14.58,14.581c0,8.053 -6.528,14.581 -14.58,14.581l-0,-29.162Z",
    style: {
      fill: "#e9f7fe",
      fillRule: "nonzero"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearning04);
export default __webpack_public_path__ + "static/media/learning-04.67db67527727e239649356f2d1600a5e.svg";
export { ForwardRef as ReactComponent };